import { Component, Injectable, Input, Compiler } from '@angular/core';
import { NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { DataPackGroup } from '../../../../../models/dataPackGroup.model';
import { DataPackLine } from '../../../../../models/dataPackLine.model';
import { DataPackValue } from '../../../../../models/dataPackValue.model';
import { AlertService } from '../../../../../utils/alert.service';
import { ConsumeService } from '../../../../../services/consume.service';

import * as _ from 'lodash';

/**
 * @version $Id: content.component.ts 63831 2017-09-23 17:42:15Z sandro.c.simas $
 */
@Component({
  selector: 'editQuotaLines',
  templateUrl: './content.modal.template.html'
})
@Injectable()
export class EditQuotaLinesComponentData5G {

  @Input() selectedGroup: DataPackGroup;
  @Input() selectedLines: Map<string, DataPackLine>;

  private saving: boolean = false;
  private quota: DataPackValue = { value: '0.0', dataPackValueType: 'GB' };
  private quotaPerLine: string;
  private pattern: string = '^\\d+$|^\\d+\\.{1}[0-9]{1}$';
  private static readonly GIGA_MIN_BALANCE: number = 0.1;

  constructor(private activeModal: NgbActiveModal, private consumeService: ConsumeService, private alertService: AlertService) {

  }

  ngOnInit() {
    if ( (null != this.selectedGroup.unallocatedQuota) && (null != this.selectedGroup.unallocatedQuota.value) ) {
      this.quotaPerLine = this.selectedGroup.unallocatedQuota.value;
      this.selectedLines.forEach((line: DataPackLine) => {
        if ( (null != line.quota) && ( null != line.quota.value) ) {
          this.quotaPerLine = (parseFloat(this.quotaPerLine) + parseFloat(line.quota.value)).toString();
        }
      });
      this.quotaPerLine = (parseFloat(this.quotaPerLine) / this.selectedLines.size).toFixed(1);
      if (this.quotaPerLine.split(".")[1] === '0') {
        this.quotaPerLine = this.quotaPerLine.split(".")[0];
      }
    } else {
      this.quotaPerLine = '0';
    }
    this.saving = false;
  }

  private commaToDot(event: any) {
    if (event.target.value && event.target.value.indexOf(',')) {
      event.target.value = event.target.value.replace(',', '.');
    }
  }

  private isLineQuotaValueValid(value: string) {
    let patt = new RegExp(this.pattern);
    return patt.test(value);
  }
  
  private updateQuota(event: any) {
    console.log('UPDATE QUOTA DO 5G');
    this.saving = true;
    this.commaToDot(event);
    let patt = new RegExp(this.pattern);
    this.saving = false;
    console.log(event);
    if (patt.test(event.target.value)) {
      if (null != this.quota.value) {
        if (Number(event.target.value) > (Number(this.quotaPerLine))) {
          this.saving = false;
          this.alertService.error('A soma das cotas atribuídas excede a franquia disponível para este grupo. Por favor reveja as configurações.', null);
          return;
        } else {
          this.selectedLines.forEach((line: DataPackLine) => {
            this.saving = false;
            let substraction = ((parseFloat(event.target.value) * 10) - Number(line.quota.value) * 10) / 10;
            if (Number(line.quotaConsumption.value) > Number(event.target.value)) {
              this.alertService.error('O valor da cota da linha ' + line.lineNumber + ' deve ser superior ao valor já consumido. Por favor reveja as configurações.',null);
              this.saving = false;
              return;
            } else if (substraction > (Number(this.selectedGroup.unallocatedQuota.value) / this.selectedLines.size)) {
              this.alertService.error('A soma das cotas atribuídas excede a franquia disponível para este grupo. Por favor reveja as configurações.',null);
              return;
            }
          });
          this.saving  = true;
        }
      }
    }
  }

  private saveLines() {
    this.saving = true;
    let payload = {
      action: 'saveLines',
      sourceGroup: {
        id: this.selectedGroup.id
     },
      lines: []
    };
    let linesQuota: number = 0;
    let isLinesQuotaInvalid: boolean = false;
    let quota: number = (!_.isNil(this.quota.value) && this.quota.value !== '') ? _.toNumber(this.quota.value) : 0;
    this.selectedLines.forEach((line: DataPackLine) => {
      if (quota < EditQuotaLinesComponentData5G.GIGA_MIN_BALANCE) {
        isLinesQuotaInvalid = true;
      }
      line.quota.value = this.quota.value;
      payload.lines.push({
        account: line.account,
        lineNumber: line.lineNumber,
        userName: line.userName,
        quota: line.quota,
        notifyManagerGroup: line.notifyManagerGroup
      });
    });
    if (isLinesQuotaInvalid) {
      this.alertService.error('Existe uma ou mais linhas sem cota configurada. Por favor finalize a configuração dessas linhas.',null);
      this.saving = false;
    } else {
      this.alertService.warn('Salvando as alterações, por favor aguarde!');
      this.consumeService.save(payload).subscribe(
        data => {
          this.alertService.success(data['result']);
          this.saving = false;
          this.activeModal.close();
        },
        err => {
          this.alertService.error(err.result, err);
          this.saving = false;
          this.activeModal.close();
        }
      );
    }
  }

  private close() {
    this.activeModal.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/consume/data5G/editQuotaLines/content.component.ts